import { c as _c } from "react/compiler-runtime";
import { type SVGProps, useId } from 'react';
function TwoUserIcon(props) {
  const $ = _c(20);
  const filterId = useId();
  const t0 = `url(#${filterId})`;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect x="12" y="10" width="20" height="20" rx="10" fill="white" shapeRendering="crispEdges" />;
    t2 = <rect x="12.5" y="10.5" width="19" height="19" rx="9.5" stroke="currentColor" strokeOpacity="0.3" shapeRendering="crispEdges" />;
    t3 = <path d="M25 24.5C25 23.4391 24.5786 22.4217 23.8284 21.6716C23.0783 20.9214 22.0609 20.5 21 20.5M21 20.5C19.9391 20.5 18.9217 20.9214 18.1716 21.6716C17.4214 22.4217 17 23.4391 17 24.5M21 20.5C22.3807 20.5 23.5 19.3807 23.5 18C23.5 16.6193 22.3807 15.5 21 15.5C19.6193 15.5 18.5 16.6193 18.5 18C18.5 19.3807 19.6193 20.5 21 20.5ZM27 24C27 22.315 26 20.75 25 20C25.3287 19.7534 25.5916 19.4295 25.7653 19.0571C25.939 18.6847 26.0183 18.2752 25.996 17.8649C25.9738 17.4546 25.8507 17.056 25.6377 16.7046C25.4248 16.3532 25.1284 16.0596 24.775 15.85" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t0) {
    t4 = <g filter={t0}>{t1}{t2}{t3}</g>;
    $[3] = t0;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <feFlood floodOpacity="0" result="BackgroundImageFix" />;
    t6 = <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />;
    t7 = <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_3523_60500" />;
    t8 = <feOffset dy="2" />;
    t9 = <feGaussianBlur stdDeviation="5" />;
    t10 = <feComposite in2="hardAlpha" operator="out" />;
    t11 = <feColorMatrix type="matrix" values="0 0 0 0 0.478431 0 0 0 0 0.227451 0 0 0 0 1 0 0 0 0.2 0" />;
    t12 = <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3523_60500" />;
    t13 = <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3523_60500" result="shape" />;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t14;
  if ($[14] !== filterId) {
    t14 = <defs><filter id={filterId} x="0" y="0" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}</filter></defs>;
    $[14] = filterId;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== props || $[17] !== t14 || $[18] !== t4) {
    t15 = <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t4}{t14}</svg>;
    $[16] = props;
    $[17] = t14;
    $[18] = t4;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  return t15;
}
export { TwoUserIcon };